


































































































































































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PurchaseOrder from "../../../store/entities/purchase-order";
import PurchaseOrderCheckIn from "../../../store/entities/purchase-order-checkin";
import Barcode from "../../components/bar-code.vue";
import InboundException from "../../components/inbound-exception.vue";
import ReceivePhysical from "../../components/receive-physical.vue";
import AppConsts from "@/lib/appconst";
import ViewPoLineException from "@/store/entities/inbound-exceptions/view-po-line-exceptions";
import PoExceptions from "@/store/entities/inbound-exceptions/po-exceptions";
import detailExpandRow from "./view-purchase-order-expand.vue";
import PurchaseOrderLine from "@/store/entities/purchase-order-line";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import { mixins } from "vue-class-component";
import _ from "lodash";
import ReceivePhysicalEntity from "@/store/entities/receive-physicals/receive-physical";
import NoteModal from "../../components/note-modal.vue";
import moment from "vue-moment";
Vue.use(require("vue-moment"));

@Component({
  components: {
    "bar-code": Barcode,
    "inbound-exception": InboundException,
    "receive-physical": ReceivePhysical,
    "note-modal": NoteModal,
  },
})
export default class ViewPurchaseOrder extends mixins(DateTimeMixin, AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  purchaseOrder: PurchaseOrder = new PurchaseOrder();
  purchaseOrderCheckIns: Array<PurchaseOrderCheckIn> = new Array<
    PurchaseOrderCheckIn
  >();
  poExceptions: PoExceptions = new PoExceptions();
  poLinePhysicals: ReceivePhysicalEntity[] = new Array<ReceivePhysicalEntity>();
  spinShow = false;
  code: string = "";
  id: number = 0;
  refTypeCode: string = AppConsts.refType.PurchaseOrder;
  poItemsKeyword: string = "";
  filterPoItems: Array<PurchaseOrderLine> = new Array<PurchaseOrderLine>();
  poItems: Array<PurchaseOrderLine> = new Array<PurchaseOrderLine>();
  sumOrderQty: number = 0;
  sumReceivedQty: number = 0;
  sumExceptionQty: number = 0;
  sumPhysicalQty: number = 0;
  sumPhysicalOrderQty: number = 0;
  sumPhysicalRealQty: number = 0;
  canReceivePhysical: boolean = true;
  cancelNote: string = "";
  noteModalShow: boolean = false;

  poReceipts: Array<any> = new Array<any>();
  poReceiptKeyword: string = "";

  poTrackings: Array<any> = new Array<any>();

  isClient() {
    return this.$store.state.session.client != null;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  getSumOrderQty() {
    if (this.poItems.length > 0) return _.sumBy(this.poItems, "orderQty");
    return 0;
  }
  getSumReceivedQty() {
    if (this.poItems.length > 0) return _.sumBy(this.poItems, "receivedQty");
    return 0;
  }
  getSumExceptionQty() {
    if (this.poItems.length > 0) return _.sumBy(this.poItems, "exceptionQty");
    return 0;
  }
  getSumPhysicalQty() {
    if (this.poItems.length > 0) return _.sumBy(this.poItems, "physicalQty");
    return 0;
  }
  getSumPhysicalOrderQty() {
    if (this.poLinePhysicals.length > 0)
      return _.sumBy(this.poLinePhysicals, "orderQty");
    return 0;
  }
  getSumPhysicalRealQty() {
    if (this.poLinePhysicals.length > 0)
      return _.sumBy(this.poLinePhysicals, "physicalQty");
    return 0;
  }
  get loading() {
    return this.$store.state.purchaseOrder.loading;
  }
  async getPoInfo() {
    await this.$store
      .dispatch({
        type: "purchaseOrder/getPoInfoByCode",
        data: { code: this.code },
      })
      .then(async (res) => {
        this.id = res.id;
        this.purchaseOrder = res;
        this.purchaseOrder.productTypeName = Util.isEmpty(
          this.purchaseOrder.productType
        )
          ? ""
          : this.purchaseOrder.productTypeName;
        this.checkPoCanReceivePhysical();
        await this.getPOExceptions();
      });
  }
  canRevertStatusToNew() {
    return (
      this.purchaseOrder.inputChannelCode != AppConsts.inputChannel.API_CRM &&
      this.purchaseOrder.type == AppConsts.poTypes.standard &&
      this.hasPermission("Operations.PurchaseOrders.Revert_Status_To_New")
    );
  }
  checkPoCanReceivePhysical() {
    this.canReceivePhysical = false;
    console.log('checkPermission', this.hasPermission(AppConsts.permissionNames.updatePurchaseOrder));
    if (
      this.purchaseOrder.inputChannelCode == AppConsts.inputChannel.API_CRM &&
      this.purchaseOrder.status == AppConsts.poStatus.new &&
      //this.isTenant() &&
      this.hasPermission(AppConsts.permissionNames.updatePurchaseOrder)
    )
      this.canReceivePhysical = true;
  }

  getPoItemsPage() {
    var items = this.poItems;
    if (!Util.isEmpty(this.poItemsKeyword)) {
      items = items.filter(
        (item) =>
          item.sku.indexOf(this.poItemsKeyword) >= 0 ||
          item.productName.indexOf(this.poItemsKeyword) >= 0
      );
    }
    var index = 0;
    var startIndex = 0;
    items.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    this.filterPoItems = items;
  }
  async refreshPoItems() {
    await this.getPoItems();
    this.getPoItemsPage();
  }
  async getPoItems() {
    await this.$store
      .dispatch({
        type: "purchaseOrder/getPoLinesInfoByPoId",
        data: { code: this.code },
      })
      .then((re) => {
        this.poItems = re;
        this.sumOrderQty = this.getSumOrderQty();
        this.sumReceivedQty = this.getSumReceivedQty();
        this.sumExceptionQty = this.getSumExceptionQty();
        this.sumPhysicalQty = this.getSumPhysicalQty();
      });
  }
  async getPoCheckIns() {
    await this.$store
      .dispatch({
        type: "purchaseOrder/getPoCheckInsByPo",
        data: { poCode: this.code },
      })
      .then((res) => {
        this.purchaseOrderCheckIns = res;
        this.orderPoCheckIns();
      });
  }
  async getPOExceptions() {
    if (!Util.isNull(this.purchaseOrder.id) && this.purchaseOrder.id > 0) {
      await this.$store.dispatch({
        type: "inboundException/getAll",
        data: {
          refId: this.purchaseOrder.id,
          refTypeCode: this.refTypeCode,
        },
      });
      this.poExceptions.items = this.$store.state.inboundException.list;
      (this.$refs.inboundException as InboundException).getpage();
    }
  }

  async getPoLineReceivePhysical() {
    await this.$store
      .dispatch({
        type: "receivePhysical/getPoLinePhysicals",
        data: {
          poId: this.purchaseOrder.id,
        },
      })
      .then((res) => {
        this.poLinePhysicals = res;
        this.sumPhysicalOrderQty = this.getSumPhysicalOrderQty();
        this.sumPhysicalRealQty = this.getSumPhysicalRealQty();
      });
  }

  orderPoCheckIns() {
    var startIndex = 0;
    var index = 0;
    this.purchaseOrderCheckIns.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
  }

  async created() {
    this.spinShow = true;
    try {
      this.code = this.$root.$router.currentRoute.params.code;
      await this.getPurchaseOrderData();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
  async getPurchaseOrderData() {
    await this.getPoInfo();
    await this.refreshPoItems();
    await this.getPoCheckIns();
    await this.getPoLineReceivePhysical();
  }
  canFinishPo() {
    if (this.purchaseOrder.finishedDate != null) {
      return false;
    }
    var poItems = this.poItems;
    var items = poItems.filter(function(item) {
      return item.orderQty > item.receivedQty + item.exceptionQty;
    });
    var re = items == null || items.length <= 0;
    return (
      this.isTenant() &&
      this.hasPermission(AppConsts.permissionNames.finishPurchaseOrder) &&
      re
    );
  }
  canCancelPo() {
    if (
      !this.hasPermission(AppConsts.permissionNames.cancelPurchaseOrder) ||
      this.purchaseOrder.status !== AppConsts.poStatus.new ||
      (!Util.isNull(this.purchaseOrder.toReqId) &&
        this.purchaseOrder.toReqId > 0)
    ) {
      return false;
    }
    return true;
  }
  openCancelNoteModal() {
    this.cancelNote = "";
    this.noteModalShow = true;
  }
  async finishPo() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.FinishPO"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        await this.$store.dispatch({
          type: "purchaseOrder/finish",
          data: this.code,
        });
        this.getPoInfo();
      },
    });
  }

  onPrintPo() {
    var url = `/#/purchaseOrder/printer/${this.code}`;
    window.open(url, "_blank");
  }
  onGoBack() {
    this.$root.$router.push({ name: "purchaseorder" });
  }
  cancelPo() {
    if (Util.isEmpty(this.cancelNote)) {
      return;
    }
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.CancelPurchaseOrder"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          await this.$store
            .dispatch({
              type: "purchaseOrder/cancel",
              data: {
                id: this.purchaseOrder.id,
                note: this.cancelNote,
              },
            })
            .then(async (esult) => {
              await this.getPurchaseOrderData();
              Util.showSuccessMsg(this, "Success.CancelPurchaseOrder");
            });
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  revertStatusToNew() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.RevertPurchaseOrderStatusToNew"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        this.$store
          .dispatch({
            type: "purchaseOrder/revertStatusToNew",
            data: {
              id: this.purchaseOrder.id,
            },
          })
          .then(async (result) => {
            await this.getPurchaseOrderData();
            Util.showSuccessMsg(this, "Success.RevertPurchaseOrderStatusToNew");
          })
          .finally(() => {
            this.spinShow = false;
          });
      },
    });
  }
  get columns() {
    return [
      {
        type: "expand",
        width: 50,
        render: (h, params) => {
          if (params.row.items.length > 0) {
            return h(detailExpandRow, {
              props: {
                row: params.row,
              },
            });
          }
          return "";
        },
      },
      {
        title: this.L("BatchCode"),
        key: "batchCode",
        width: 200,
      },
      {
        title: this.L("SKU"),
        width: 200,
        key: "sku",
      },
      {
        title: this.L("ProductName"),
        key: "productName",
        width: 250,
      },
      {
        title: this.L("UnitName"),
        key: "unitName",
        width: 100,
      },
      {
        title: `${this.L("OrderQty")} (${Util.toViewNumberString(
          this.sumOrderQty
        )})`,
        key: "orderQty",
        align: "right",
        width: 100,
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.orderQty));
        },
      },
      {
        title: this.L("ManufactureMonth"),
        key: "manufactureMonth",
        width: 100,
        render: (h: any, params: any) => {
          if (
            Util.isNull(params.row.manufactureMonth) ||
            Util.isEmpty(params.row.manufactureMonth.toString())
          )
            return "";
          return h("span", Util.toMonthYearString(params.row.manufactureMonth));
        },
      },
      {
        title: this.L("Price"),
        key: "price",
        align: "right",
        width: 100,
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.price));
        },
      },
      {
        title: this.L("Tax"),
        key: "tax",
        align: "right",
        width: 100,
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.tax));
        },
      },
      {
        title: this.L("TotalAmount"),
        key: "amount",
        align: "right",
        width: 100,
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.amount));
        },
      },
      {
        title: `${this.L("ReceivedQty")} (${Util.toViewNumberString(
          this.sumReceivedQty
        )})`,
        key: "receivedQty",
        align: "right",
        width: 100,
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.receivedQty));
        },
      },
      {
        title: `${this.L("ExceptionQty")} (${Util.toViewNumberString(
          this.sumExceptionQty
        )})`,
        key: "exceptionQty",
        align: "right",
        width: 100,
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.exceptionQty));
        },
      },
      {
        title: `${this.L("PhysicalQty")} (${Util.toViewNumberString(
          this.sumExceptionQty
        )})`,
        key: "physicalQty",
        align: "right",
        width: 100,
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.physicalQty));
        },
      },
      {
        title: this.L("Note"),
        key: "note",
        width: 200,
      },
    ];
  }

  columnsPoCheckIns = [
    {
      title: this.L("Order"),
      key: "orderNo",
      width: 50,
    },
    {
      title: this.L("PoCheckInCode"),
      width: 200,
      key: "code",
    },
    {
      title: this.L("NumOfPacks"),
      key: "numOfPacks",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.numOfPacks));
      },
    },
    {
      title: this.L("ContainerNumber"),
      key: "containerNumber",
    },
    {
      title: this.L("DriverName"),
      key: "driverName",
    },
    {
      title: this.L("DriverPhone"),
      key: "driverPhone",
    },
    {
      title: Util.L("ArrivedAt"),
      key: "arrivedAt",
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.arrivedAt));
      },
    },
    {
      title: Util.L("Action"),
      width: 100,
      slot: "action",
      align: "center",
    },
  ];
  rowDetailClassName(row, index) {
    if (row.receivedQty > 0 && row.receivedQty < row.orderQty) {
      return "demo-table-info-row";
    }

    return "";
  }

  tabsOnClick(name: string) {
    switch (name) {
      case "poReceipts":
        this.getPoReceipts();
        break;
      case "poTrackings":
        this.getPoTrackings();
        break;
    }
  }

  async getPoReceipts() {
    if (!Util.isNull(this.purchaseOrder.id) && this.purchaseOrder.id > 0) {
      await this.$store.dispatch({
        type: "poReceipt/getAll",
        data: {
          warehouseCode: this.purchaseOrder.warehouseCode,
          clientCode: this.purchaseOrder.clientCode,
          poId: this.purchaseOrder.id,
          keyword: this.poReceiptKeyword,
        },
      });
      this.poReceipts = this.$store.state.poReceipt.list;
      var startIndex = (this.currentPagePoReceipt - 1) * this.pageSizePoReceipt;
      var index = 0;
      this.poReceipts.forEach(function(item) {
        item.isSelected = false;
        item.orderNo = startIndex + index + 1;
        index++;
      });
    }
  }

  onSelect(selection, row) {
    this.$emit("on-select", selection, row);
  }
  onSelectCancel(selection, row) {
    this.$emit("on-select-cancel", selection, row);
  }
  onSelectAll(selection) {
    this.$emit("on-select-all", selection);
  }
  onSelectionChange(selection) {
    this.$emit("on-selection-change", selection);
    _.forEach(this.poReceipts, (o) => {
      var itemSelected = _.find(selection, function(x) {
        return x.id === o.id;
      });
      if (itemSelected) {
        o.isSelected = true;
      } else {
        o.isSelected = false;
      }
    });
  }

  sendEmailPoReceipt() {
    const poReceiptsSelected = _.filter(this.poReceipts, function(o) {
      return o.isSelected === true;
    });
    if (poReceiptsSelected.length == 0) {
      Util.showErrorMsg(this, "RequireToSelectPoReceiptSendMail");
      return;
    }

    const ids = [];
    _.map(poReceiptsSelected, (o) => ids.push(o.id));
    this.$store
      .dispatch({
        type: "purchaseOrder/sendPoReceiptMail",
        data: ids,
      })
      .then(() => {
        Util.showSuccessMsg(this, "SendMailSuccess");
      });
  }

  get pageSizePoReceipt() {
    return this.$store.state.poReceipt.pageSize;
  }
  get totalCountPoReceipt() {
    return this.$store.state.poReceipt.totalCount;
  }
  get currentPagePoReceipt() {
    return this.$store.state.poReceipt.currentPage;
  }
  pageChangePoReceipt(page: number) {
    this.$store.commit(`poReceipt/setCurrentPage`, page);
    this.getPoReceipts();
  }
  pagesizeChangePoReceipt(pagesize: number) {
    this.$store.commit(`poReceipt/setPageSize`, pagesize);
    this.getPoReceipts();
  }

  columnsPoReceipts = [
    {
      title: this.L("Order"),
      key: "orderNo",
      width: 50,
    },
    {
      title: this.L("PoReceiptCode"),
      width: 200,
      slot: "PoReceiptCode",
    },
    {
      title: this.L("ExternalCode"),
      render: (h: any, params: any) => {
        return h("span", params.row.po.externalCode);
      },
    },
    {
      title: Util.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.creationTime));
      },
    },
    {
      title: this.L("LastTimeMailSent"),
      render: (h: any, params: any) => {
        return _.isEmpty(params.row.lastTimeMailSent)
          ? ""
          : h("span", Util.toViewDateString(params.row.lastTimeMailSent));
      },
    },
    {
      title: this.L("LastTimeMailSentBy"),
      render: (h: any, params: any) => {
        return _.isEmpty(params.row.userSentBy)
          ? ""
          : h(
              "span",
              `${params.row.userSentBy.userName} - ${
                params.row.userSentBy.name
              }`
            );
      },
    },
    {
      type: "selection",
      width: 50,
      fixed: "right",
    },
  ];

  async getPoTrackings() {
    if (!Util.isNull(this.purchaseOrder.id) && this.purchaseOrder.id > 0) {
      await this.$store.dispatch({
        type: "poTracking/getAll",
        data: {
          poCode: this.purchaseOrder.code,
          maxResultCount: this.pageSizePoTracking,
          skipCount: (this.currentPagePoTracking - 1) * this.pageSizePoTracking,
        },
      });
      this.poTrackings = this.$store.state.poTracking.list;
      var startIndex =
        (this.currentPagePoTracking - 1) * this.pageSizePoTracking;
      var index = 0;
      this.poTrackings.forEach(function(item) {
        item.orderNo = startIndex + index + 1;
        index++;
      });
    }
  }

  get pageSizePoTracking() {
    return this.$store.state.poTracking.pageSize;
  }
  get totalCountPoTracking() {
    return this.$store.state.poTracking.totalCount;
  }
  get currentPagePoTracking() {
    return this.$store.state.poTracking.currentPage;
  }
  pageChangePoTracking(page: number) {
    this.$store.commit(`poTracking/setCurrentPage`, page);
    this.getPoTrackings();
  }
  pagesizeChangePoTracking(pagesize: number) {
    this.$store.commit(`poTracking/setPageSize`, pagesize);
    this.getPoTrackings();
  }

  columnsPoTrackings = [
    {
      title: this.L("Order"),
      key: "orderNo",
      width: 50,
    },
    {
      title: this.L("OldStatusName"),
      key: "oldStatusName",
    },
    {
      title: this.L("NewStatusName"),
      key: "newStatusName",
    },
    {
      title: this.L("ActionType"),
      key: "actionTypeName",
    },
    {
      title: this.L("InputChannelCode"),
      key: "inputChannelName",
    },
    {
      title: Util.L("ActionTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.creationTime));
      },
    },
    {
      title: this.L("ActionUser"),
      render: (h: any, params: any) => {
        return h(
          "span",
          `${params.row.creatorUser.userName} - ${params.row.creatorUser.name}`
        );
      },
    },
    {
      title: this.L("Content"),
      key: "content",
    },
  ];
}
